const dataDisplayOptions = [
  { value: 'Outpatient', label: 'Outpatient' },
  // { value: 'flu_index1', label: 'Respiratory Syncytial Virus (RSV)' },
  // { value: 'flu_index2', label: 'Non-Influenza Pneumonia' },
  // { value: 'flu_index3', label: 'Pure flu' },
  // { value: 'flu_index4', label: 'Respiratory Syncytial Virus (RSV)' },
]

export default dataDisplayOptions
